import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import DashboardService from '../../../core/service'

export const getSavedPortfolio = createAsyncThunk(
  'dashboard/yourPortfolio/getSavedPortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getSavedPortfolio({
        Page: 1,
        PageSize: 300,
        ...params,
      })
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getCreditRiskScore = createAsyncThunk(
  'dashboard/yourPortfolio/getCreditRiskScore',
  async (params, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getCreditRiskScore(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getPerformanceScore = createAsyncThunk(
  'dashboard/yourPortfolio/getPerformanceScore',
  async (params, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getPerformanceScore(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
